module.exports = __webpack_public_path__ + "img/icon-16-ic-offline-small.957ca0cc.svg";